document.addEventListener("DOMContentLoaded", function () {
    const skewSections = document.querySelectorAll('.js-skew'); 
    const skewMaxValue = 20;
    const skewMinValue = skewMaxValue * -1;

    for (const skewSection of skewSections) {

        let skewCurrentPosition = window.scrollY;

        const skewing = () => {
            const skewNewPosition = window.scrollY;
            let skewDifference = skewNewPosition - skewCurrentPosition;
            (skewDifference > 0 && skewDifference > skewMaxValue) ? skewDifference = skewMaxValue : skewDifference = skewDifference;
            (skewDifference < 0 && skewDifference < skewMinValue) ? skewDifference = skewMinValue : skewDifference = skewDifference;
            const skewSpeed = skewDifference * 0.10 * -1;
            
            skewSection.style.transform = `skewY(${ skewSpeed }deg)`;
            
            skewCurrentPosition = skewNewPosition;
            requestAnimationFrame(skewing);
        }
        skewing();

    }
});

